// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:base-models --tenant projectReplica` to regenerate.
import DatabaseRecord from "velocious/build/src/database/record/index.js"

/**
 * Attributes accepted when creating or updating Task records.
 * @typedef {object} TaskWriteAttributes
 * @property {string} [id] - Value for the id attribute.
 * @property {string | null} [projectId] - Value for the projectId attribute.
 * @property {string | null} [taskTypeId] - Value for the taskTypeId attribute.
 * @property {string | null} [userId] - Value for the userId attribute.
 * @property {string | null} [parentId] - Value for the parentId attribute.
 * @property {string | null} [name] - Value for the name attribute.
 * @property {string | null} [description] - Value for the description attribute.
 * @property {string | null} [state] - Value for the state attribute.
 * @property {number | null} [priority] - Value for the priority attribute.
 * @property {Date | string} [createdAt] - Value for the createdAt attribute.
 * @property {Date | string} [updatedAt] - Value for the updatedAt attribute.
 * @property {Date | string | null} [lastSyncChangeAt] - Value for the lastSyncChangeAt attribute.
 * @property {string | null} [agentState] - Value for the agentState attribute.
 * @property {string | null} [agentClaimedBy] - Value for the agentClaimedBy attribute.
 * @property {string | null} [automationRuntimeStatus] - Value for the automationRuntimeStatus attribute.
 * @property {Record<string, unknown> | null} [automationRuntimeLinks] - Value for the automationRuntimeLinks attribute.
 * @property {import("../models/task.js").default} [parent] - Related parent record.
 * @property {import("../models/task-type.js").default} [taskType] - Related taskType record.
 */

/** @augments {DatabaseRecord<TaskWriteAttributes>} */
export default class TaskBase extends DatabaseRecord {
  /** @returns {typeof import("../models/task.js").default} */
  // @ts-ignore - override narrows return type for better IntelliSense in generated model bases
  getModelClass() { return /** @type {typeof import("../models/task.js").default} */ (this.constructor) }

  /** @returns {string} */
  id() { return this.readAttribute("id") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setId(newValue) { return this._setColumnAttribute("id", newValue) }

  /** @returns {boolean} */
  hasId() { return this._hasAttribute(this.id()) }

  /** @returns {string | null} */
  projectId() { return this.readAttribute("projectId") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setProjectId(newValue) { return this._setColumnAttribute("projectId", newValue) }

  /** @returns {boolean} */
  hasProjectId() { return this._hasAttribute(this.projectId()) }

  /** @returns {string | null} */
  taskTypeId() { return this.readAttribute("taskTypeId") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setTaskTypeId(newValue) { return this._setColumnAttribute("taskTypeId", newValue) }

  /** @returns {boolean} */
  hasTaskTypeId() { return this._hasAttribute(this.taskTypeId()) }

  /** @returns {string | null} */
  userId() { return this.readAttribute("userId") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setUserId(newValue) { return this._setColumnAttribute("userId", newValue) }

  /** @returns {boolean} */
  hasUserId() { return this._hasAttribute(this.userId()) }

  /** @returns {string | null} */
  parentId() { return this.readAttribute("parentId") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setParentId(newValue) { return this._setColumnAttribute("parentId", newValue) }

  /** @returns {boolean} */
  hasParentId() { return this._hasAttribute(this.parentId()) }

  /** @returns {string | null} */
  name() { return this.readAttribute("name") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setName(newValue) { return this._setColumnAttribute("name", newValue) }

  /** @returns {boolean} */
  hasName() { return this._hasAttribute(this.name()) }

  /** @returns {string | null} */
  description() { return this.readAttribute("description") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setDescription(newValue) { return this._setColumnAttribute("description", newValue) }

  /** @returns {boolean} */
  hasDescription() { return this._hasAttribute(this.description()) }

  /** @returns {string | null} */
  state() { return this.readAttribute("state") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setState(newValue) { return this._setColumnAttribute("state", newValue) }

  /** @returns {boolean} */
  hasState() { return this._hasAttribute(this.state()) }

  /** @returns {number | null} */
  priority() { return this.readAttribute("priority") }

  /**
   * @param {number | null} newValue
   * @returns {void}
   */
  setPriority(newValue) { return this._setColumnAttribute("priority", newValue) }

  /** @returns {boolean} */
  hasPriority() { return this._hasAttribute(this.priority()) }

  /** @returns {Date} */
  createdAt() { return this.readAttribute("createdAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setCreatedAt(newValue) { return this._setColumnAttribute("createdAt", newValue) }

  /** @returns {boolean} */
  hasCreatedAt() { return this._hasAttribute(this.createdAt()) }

  /** @returns {Date} */
  updatedAt() { return this.readAttribute("updatedAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setUpdatedAt(newValue) { return this._setColumnAttribute("updatedAt", newValue) }

  /** @returns {boolean} */
  hasUpdatedAt() { return this._hasAttribute(this.updatedAt()) }

  /** @returns {Date | null} */
  lastSyncChangeAt() { return this.readAttribute("lastSyncChangeAt") }

  /**
   * @param {Date | string | null} newValue
   * @returns {void}
   */
  setLastSyncChangeAt(newValue) { return this._setColumnAttribute("lastSyncChangeAt", newValue) }

  /** @returns {boolean} */
  hasLastSyncChangeAt() { return this._hasAttribute(this.lastSyncChangeAt()) }

  /** @returns {string | null} */
  agentState() { return this.readAttribute("agentState") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setAgentState(newValue) { return this._setColumnAttribute("agentState", newValue) }

  /** @returns {boolean} */
  hasAgentState() { return this._hasAttribute(this.agentState()) }

  /** @returns {string | null} */
  agentClaimedBy() { return this.readAttribute("agentClaimedBy") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setAgentClaimedBy(newValue) { return this._setColumnAttribute("agentClaimedBy", newValue) }

  /** @returns {boolean} */
  hasAgentClaimedBy() { return this._hasAttribute(this.agentClaimedBy()) }

  /** @returns {string | null} */
  automationRuntimeStatus() { return this.readAttribute("automationRuntimeStatus") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setAutomationRuntimeStatus(newValue) { return this._setColumnAttribute("automationRuntimeStatus", newValue) }

  /** @returns {boolean} */
  hasAutomationRuntimeStatus() { return this._hasAttribute(this.automationRuntimeStatus()) }

  /** @returns {Record<string, unknown> | null} */
  automationRuntimeLinks() { return this.readAttribute("automationRuntimeLinks") }

  /**
   * @param {Record<string, unknown> | null} newValue
   * @returns {void}
   */
  setAutomationRuntimeLinks(newValue) { return this._setColumnAttribute("automationRuntimeLinks", newValue) }

  /** @returns {boolean} */
  hasAutomationRuntimeLinks() { return this._hasAttribute(this.automationRuntimeLinks()) }

  /**
   * @returns {import("../models/task.js").default}
   */
  parent() { return /** @type {import("../models/task.js").default} */ (this.getRelationshipByName("parent").loaded()) }

  /**
   * @abstract
   * @param {ConstructorParameters<typeof import("../models/task.js").default>[0]} [attributes]
   * @returns {import("../models/task.js").default}
   */
  buildParent(attributes) { void attributes; throw new Error("Not implemented") }

  /**
   * @abstract
   * @returns {Promise<import("../models/task.js").default | undefined>}
   */
  loadParent() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<import("../models/task.js").default | undefined>}
   */
  parentOrLoad() { return /** @type {Promise<import("../models/task.js").default | undefined>} */ (this.relationshipOrLoad("parent")) }

  /**
   * @abstract
   * @param {import("../models/task.js").default} newModel
   * @returns {void}
   */
  setParent(newModel) { void newModel; throw new Error("Not implemented") }

  /**
   * @returns {import("../models/task-type.js").default}
   */
  taskType() { return /** @type {import("../models/task-type.js").default} */ (this.getRelationshipByName("taskType").loaded()) }

  /**
   * @abstract
   * @param {ConstructorParameters<typeof import("../models/task-type.js").default>[0]} [attributes]
   * @returns {import("../models/task-type.js").default}
   */
  buildTaskType(attributes) { void attributes; throw new Error("Not implemented") }

  /**
   * @abstract
   * @returns {Promise<import("../models/task-type.js").default | undefined>}
   */
  loadTaskType() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<import("../models/task-type.js").default | undefined>}
   */
  taskTypeOrLoad() { return /** @type {Promise<import("../models/task-type.js").default | undefined>} */ (this.relationshipOrLoad("taskType")) }

  /**
   * @abstract
   * @param {import("../models/task-type.js").default} newModel
   * @returns {void}
   */
  setTaskType(newModel) { void newModel; throw new Error("Not implemented") }

  /**
   * @returns {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/task.js").default, typeof import("../models/task.js").default>}
   */
  children() { return /** @type {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/task.js").default, typeof import("../models/task.js").default>} */ (this.getRelationshipByName("children")) }

  /**
   * @returns {Array<import("../models/task.js").default>}
   */
  childrenLoaded() { return /** @type {Array<import("../models/task.js").default>} */ (this.getRelationshipByName("children").loaded()) }

  /**
   * @abstract
   * @returns {Promise<Array<import("../models/task.js").default>>}
   */
  loadChildren() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<Array<import("../models/task.js").default>>}
   */
  childrenOrLoad() { return /** @type {Promise<Array<import("../models/task.js").default>>} */ (this.relationshipOrLoad("children")) }

  /**
   * @abstract
   * @param {Array<import("../models/task.js").default>} newModels
   * @returns {void}
   */
  setChildren(newModels) { void newModels; throw new Error("Not implemented") }

  /**
   * @returns {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/task.js").default, typeof import("../models/comment.js").default>}
   */
  comments() { return /** @type {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/task.js").default, typeof import("../models/comment.js").default>} */ (this.getRelationshipByName("comments")) }

  /**
   * @returns {Array<import("../models/comment.js").default>}
   */
  commentsLoaded() { return /** @type {Array<import("../models/comment.js").default>} */ (this.getRelationshipByName("comments").loaded()) }

  /**
   * @abstract
   * @returns {Promise<Array<import("../models/comment.js").default>>}
   */
  loadComments() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<Array<import("../models/comment.js").default>>}
   */
  commentsOrLoad() { return /** @type {Promise<Array<import("../models/comment.js").default>>} */ (this.relationshipOrLoad("comments")) }

  /**
   * @abstract
   * @param {Array<import("../models/comment.js").default>} newModels
   * @returns {void}
   */
  setComments(newModels) { void newModels; throw new Error("Not implemented") }

  /**
   * @returns {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/task.js").default, typeof import("../models/task-assigned-user.js").default>}
   */
  taskAssignedUsers() { return /** @type {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/task.js").default, typeof import("../models/task-assigned-user.js").default>} */ (this.getRelationshipByName("taskAssignedUsers")) }

  /**
   * @returns {Array<import("../models/task-assigned-user.js").default>}
   */
  taskAssignedUsersLoaded() { return /** @type {Array<import("../models/task-assigned-user.js").default>} */ (this.getRelationshipByName("taskAssignedUsers").loaded()) }

  /**
   * @abstract
   * @returns {Promise<Array<import("../models/task-assigned-user.js").default>>}
   */
  loadTaskAssignedUsers() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<Array<import("../models/task-assigned-user.js").default>>}
   */
  taskAssignedUsersOrLoad() { return /** @type {Promise<Array<import("../models/task-assigned-user.js").default>>} */ (this.relationshipOrLoad("taskAssignedUsers")) }

  /**
   * @abstract
   * @param {Array<import("../models/task-assigned-user.js").default>} newModels
   * @returns {void}
   */
  setTaskAssignedUsers(newModels) { void newModels; throw new Error("Not implemented") }

  /**
   * @returns {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/task.js").default, typeof import("../models/task-board.js").default>}
   */
  taskBoards() { return /** @type {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/task.js").default, typeof import("../models/task-board.js").default>} */ (this.getRelationshipByName("taskBoards")) }

  /**
   * @returns {Array<import("../models/task-board.js").default>}
   */
  taskBoardsLoaded() { return /** @type {Array<import("../models/task-board.js").default>} */ (this.getRelationshipByName("taskBoards").loaded()) }

  /**
   * @abstract
   * @returns {Promise<Array<import("../models/task-board.js").default>>}
   */
  loadTaskBoards() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<Array<import("../models/task-board.js").default>>}
   */
  taskBoardsOrLoad() { return /** @type {Promise<Array<import("../models/task-board.js").default>>} */ (this.relationshipOrLoad("taskBoards")) }

  /**
   * @abstract
   * @param {Array<import("../models/task-board.js").default>} newModels
   * @returns {void}
   */
  setTaskBoards(newModels) { void newModels; throw new Error("Not implemented") }

  /**
   * @returns {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/task.js").default, typeof import("../models/timelog.js").default>}
   */
  timelogs() { return /** @type {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/task.js").default, typeof import("../models/timelog.js").default>} */ (this.getRelationshipByName("timelogs")) }

  /**
   * @returns {Array<import("../models/timelog.js").default>}
   */
  timelogsLoaded() { return /** @type {Array<import("../models/timelog.js").default>} */ (this.getRelationshipByName("timelogs").loaded()) }

  /**
   * @abstract
   * @returns {Promise<Array<import("../models/timelog.js").default>>}
   */
  loadTimelogs() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<Array<import("../models/timelog.js").default>>}
   */
  timelogsOrLoad() { return /** @type {Promise<Array<import("../models/timelog.js").default>>} */ (this.relationshipOrLoad("timelogs")) }

  /**
   * @abstract
   * @param {Array<import("../models/timelog.js").default>} newModels
   * @returns {void}
   */
  setTimelogs(newModels) { void newModels; throw new Error("Not implemented") }
}
